import { DOMParser } from "@xmldom/xmldom";
import xpath from "xpath";

export const XpathFieldIdPrefix = "CX.";

export const ValidateXPathXpression = (xpathExpression: string) => {
  try {
    const doc = new DOMParser().parseFromString("<root></root>", "text/xml");
    xpath.select(xpathExpression, doc as any);
    return { isValid: true, message: "XPath Expression is valid" };
  } catch (e) {
    return { isValid: false, message: "XPath Expression is invalid" };
  }
};